import React, { useState, useCallback, useEffect } from "react";
import style from "./index.module.scss";
import cn from "classnames";
import AppTooltip from "../../shared/AppTooltip/AppTooltip";

const CustomToggleSwitch = ({
  onToggle = () => {},
  defaultValue = false,
  value,
  disabled = false,
  size = "md", // "sm" | "md" | "lg"
  tooltip,
  tooltipId = "custom-toggle-tooltip",
}) => {
  const [isChecked, setIsChecked] = useState(Boolean(defaultValue));

  useEffect(() => {
    if (value !== undefined) {
      setIsChecked(Boolean(value));
    }
  }, [value]);

  const toggle = useCallback(() => {
    if (disabled) return;
    const next = !isChecked;
    
    if (value !== undefined) {
      onToggle(next);
    } else {
      setIsChecked(next);
      onToggle(next);
    }
  }, [isChecked, onToggle, disabled, value]);

  return (
    <>
      <div
        role="switch"
        aria-checked={isChecked}
        tabIndex={disabled ? -1 : 0}
        aria-disabled={disabled}
        className={cn(style.switch, style[`size_${size}`], {
          [style.checked]: isChecked,
          [style.disabled]: disabled,
        })}
        onClick={toggle}
        data-tooltip-id={tooltip ? tooltipId : undefined}
      >
        <div className={style.track}>
          <div className={style.knob}></div>
        </div>
      </div>
      {tooltip && (
        <AppTooltip id={tooltipId} place="top" positionStrategy="fixed">
          {tooltip}
        </AppTooltip>
      )}
    </>
  );
};

export default CustomToggleSwitch;
